<div class="">
    <div *ngIf="isLoading" class="progress-bar-container">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div class="pt-4 flex justify-center pb-4">
        <div class="rounded-lg shadow-2xl bg-card w-full mx-8 px-4">
            <!-- Header Tela -->
            <div
                *ngIf="!isMobile"
                class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-3">
                <!-- Título -->
                <div
                    class="flex items-center font-sans text-xl text-neutral-500 font-bold">
                    Visão geral - Estoques
                </div>

                <!-- Filtros -->
                <div class="grid grid-cols-2 gap-4">
                    <mat-form-field class="w-full">
                        <mat-select
                            [(ngModel)]="selectedRegional"
                            (selectionChange)="
                                onChangeRegional(
                                    $event.value,
                                    $event.source.triggerValue
                                )
                            "
                            placeholder="Selecione a regional">
                            <mat-option [value]="null">Nenhuma</mat-option>
                            <mat-option
                                *ngFor="let regional of regionals"
                                [value]="regional.id">
                                {{ regional.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="w-full">
                        <mat-select
                            [(ngModel)]="selectedFarm"
                            (selectionChange)="
                                onChangeFarm(
                                    $event.value,
                                    $event.source.triggerValue
                                )
                            "
                            placeholder="Selecione a fazenda">
                            <mat-option [value]="null">Nenhuma</mat-option>
                            <mat-option
                                *ngFor="let farm of farms"
                                [value]="farm.id">
                                {{ farm.farm_name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Filtros para Tela -->
            <div *ngIf="!isMobile" class="grid w-full justify-end border-b">
                <ng-container *ngIf="filters && filters.length">
                    <div
                        class="flex flex-wrap items-center mx-1 justify-end pb-2 pr-3">
                        <ng-container *ngFor="let filter of filters">
                            <div
                                class="flex items-center m-1 py-0.5 px-3 rounded-full text-sm font-medium text-gray-500 bg-gray-200">
                                <div>
                                    <strong>{{ filter.label }}</strong
                                    >: {{ filter.value }}
                                </div>
                                <mat-icon
                                    class="ml-1 icon-size-4 cursor-pointer"
                                    [svgIcon]="'heroicons_solid:x-circle'"
                                    (click)="removeFilter(filter)"></mat-icon>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>

            <!-- Content Cards Tela -->
            <div
                *ngIf="!isMobile"
                class="grid grid-cols-2 md:grid-cols-4 pt-5 pl-4 gap-y-4">
                <div
                    class="rounded-lg shadow-lg bg-card w-11/12 pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Estoques Controlados</div>
                        <div class="text-3xl font-bold py-2">
                            {{ overview.totalRecords || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{ 100 }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-11/12 pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Total Geral em Estoques</div>
                        <div class="text-3xl font-bold py-2">
                            {{ overview.totalGlobalStock || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{ 100 }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-11/12 pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Total de Lotes controlados</div>
                        <div class="text-3xl font-bold py-2">
                            {{ totalBatches || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{ 100 }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-11/12 pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Lotes Expirando</div>
                        <div class="text-3xl font-bold py-2">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:exclamation-circle'"
                                class="text-yellow-600">
                            </mat-icon>
                            &nbsp;<font color="#D97706">{{
                                nearingExpiryCount || 0 | number
                            }}</font>
                        </div>
                        <div class="text-sm">
                            Representa
                            {{
                                (nearingExpiryCount / totalBatches) * 100
                                    | number : '1.2-2'
                            }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-11/12 pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Lotes Bloqueados</div>
                        <div class="text-3xl font-bold py-2">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:fire'"
                                class="text-red-500"></mat-icon>
                            &nbsp;<font color="red">{{
                                blockedCount || 0 | number
                            }}</font>
                        </div>
                        <div class="text-sm">
                            Representa
                            {{
                                (blockedCount / totalBatches) * 100
                                    | number : '1.2-2'
                            }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-11/12 pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">
                            Lotes <strong>OnDemand</strong>
                        </div>
                        <div class="text-3xl font-bold py-2">
                            {{ modeDistribution.OnDemand || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{
                                (modeDistribution.OnDemand / totalBatches) * 100
                                    | number : '1.2-2'
                            }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-11/12 pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Lotes <strong>OnFarm</strong></div>
                        <div class="text-3xl font-bold py-2">
                            {{ modeDistribution.OnFarm || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{
                                (modeDistribution.OnFarm / totalBatches) * 100
                                    | number : '1.2-2'
                            }}%
                        </div>
                    </div>
                </div>

                <!-- <div class="col-span-1 grid-container">
                    <label>Tema de cores</label> &nbsp;
                    <label>
                        <input
                            type="radio"
                            name="theme"
                            value="BI"
                            [(ngModel)]="selectedTheme"
                            (change)="onThemeChange()" />
                        BI
                    </label>
                    &nbsp;
                    <label>
                        <input
                            type="radio"
                            name="theme"
                            value="App"
                            [(ngModel)]="selectedTheme"
                            (change)="onThemeChange()" />
                        OnFarm
                    </label>
                </div> -->

                <div class="flex justify-end w-11/12">
                    <div class="flex py-5 items-center">
                        <button
                            class="ml-4 bg-gray-500 text-white text-sm"
                            mat-flat-button
                            (click)="switchTab()">
                            <span class="ml-2 mr-1"
                                >Acessar Lista de Estoques</span
                            >
                        </button>
                    </div>
                </div>
            </div>

            <!-- Content Charts description Tela-->
            <div
                *ngIf="!isMobile"
                class="grid grid-cols-2 md:grid-cols-4 pt-5 pl-4 gap-y-4">
                <div class="col-span-2 flex justify-center">
                    <div
                        class="text-md font-bold text-center"
                        style="color: rgb(115, 115, 155)">
                        Distribuição de Lotes: OnFarm | OnDemand
                    </div>
                </div>
                <div class="col-span-2 flex justify-center">
                    <div
                        class="text-md font-bold text-center"
                        style="color: rgb(115, 115, 155)">
                        Top 10 Produtos - Mais próximos do mínimo
                    </div>
                </div>
            </div>

            <!-- Tela - Content Charts Pizza e barras Lado a Lado-->
            <div
                *ngIf="!isMobile"
                class="pt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
                <!-- Gráfico de Pizza -->
                <div class="w-full grid grid-cols-3 gap-4 items-start">
                    <!-- Gráfico: col-span-2 (2/3) -->
                    <div class="col-span-2 flex justify-center">
                        <div class="w-full h-[250px] max-w-[60%]">
                            <apx-chart
                                [series]="charrt.series"
                                [chart]="charrt.chart"
                                [labels]="charrt.labels"
                                [legend]="charrt.legend"
                                [dataLabels]="charrt.dataLabels"
                                [colors]="charrt.colors"
                                class="w-full h-full">
                            </apx-chart>
                        </div>
                    </div>

                    <!-- Legenda: 1/3 ao lado do gráfico, centralizada verticalmente -->
                    <div
                        class="col-span-1 flex items-center justify-center w-full h-full mr-30"
                        *ngIf="hasPieChartData()">
                        <div class="w-full px-6">
                            <div class="space-y-2">
                                <div
                                    *ngFor="
                                        let label of charrt.labels;
                                        let i = index
                                    "
                                    class="flex items-center justify-between border-b pb-1 mr-8">
                                    <div class="flex items-center gap-2">
                                        <div
                                            class="w-4 h-4 rounded-full"
                                            [style.backgroundColor]="
                                                charrt.colors[i]
                                            "></div>
                                        <span
                                            class="text-sm text-neutral-600"
                                            >{{ label }}</span
                                        >
                                    </div>
                                    <span
                                        class="text-sm font-bold text-neutral-800">
                                        {{ charrt.series[i] }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Gráfico de Barras -->
                <div
                    class="rounded-lg bg-card p-4 flex-col justify-between col-span-1">
                    <div class="overflow-x-auto">
                        <ng-container
                            *ngIf="
                                hasBarChartop10ProductsData();
                                else noBarDataProducts
                            ">
                            <apx-chart
                                [series]="barChartOptions.series"
                                [chart]="barChartOptions.chart"
                                [xaxis]="barChartOptions.xaxis"
                                [yaxis]="barChartOptions.yaxis"
                                [plotOptions]="barChartOptions.plotOptions"
                                [dataLabels]="barChartOptions.dataLabels"
                                [colors]="barChartOptions.colors"
                                [tooltip]="barChartOptions.tooltip">
                            </apx-chart>
                        </ng-container>
                        <ng-template #noBarDataProducts>
                            <div
                                class="col-span-3 flex items-center justify-center h-[300px]">
                                <span class="text-sm text-gray-500">
                                    Nenhum dado disponível para o gráfico.
                                </span>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div
                *ngIf="!isMobile"
                class="grid grid-cols-2 md:grid-cols-4 pt-5 pl-4 gap-y-4 mt-10">
                <div class="col-span-2 flex justify-center">
                    <div
                        class="text-md font-bold text-center"
                        style="color: rgb(115, 115, 155)">
                        Top 5 Produtos - Abaixo do Mínimo
                    </div>
                </div>
                <div class="col-span-2 flex justify-center">
                    <div
                        class="text-md font-bold text-center"
                        style="color: rgb(115, 115, 155)">
                        Top 5 - Estoques por Fazenda
                    </div>
                </div>
            </div>

            <!-- Tela - Gráficos em uma única linha: Fazenda + Abaixo do Mínimo -->
            <div
                *ngIf="!isMobile"
                class="pt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
                <!-- Gráfico de Produtos Abaixo do Mínimo -->
                <div class="bg-card p-4 w-full overflow-x-auto">
                    <ng-container
                        *ngIf="hasBarChartBelowMinimumData(); else noBelowMin">
                        <apx-chart
                            [series]="barChartBelowMinimumOptions.series"
                            [chart]="barChartBelowMinimumOptions.chart"
                            [xaxis]="barChartBelowMinimumOptions.xaxis"
                            [yaxis]="barChartBelowMinimumOptions.yaxis"
                            [plotOptions]="
                                barChartBelowMinimumOptions.plotOptions
                            "
                            [dataLabels]="
                                barChartBelowMinimumOptions.dataLabels
                            "
                            [colors]="barChartBelowMinimumOptions.colors"
                            [tooltip]="barChartBelowMinimumOptions.tooltip"
                            class="w-full h-full">
                        </apx-chart>
                    </ng-container>

                    <ng-template #noBelowMin>
                        <div class="flex justify-center h-[300px] items-center">
                            <span class="text-sm text-gray-500">
                                Nenhum produto está abaixo do mínimo atualmente.
                            </span>
                        </div>
                    </ng-template>
                </div>

                <!-- Gráfico de Estoque por Fazenda -->
                <div class="bg-card p-4 w-full overflow-x-auto">
                    <ng-container
                        *ngIf="hasBarChartop10FarmsData(); else noBarFarmData">
                        <apx-chart
                            [series]="barChartFarmOptions.series"
                            [chart]="barChartFarmOptions.chart"
                            [xaxis]="barChartFarmOptions.xaxis"
                            [yaxis]="barChartFarmOptions.yaxis"
                            [plotOptions]="barChartFarmOptions.plotOptions"
                            [dataLabels]="barChartFarmOptions.dataLabels"
                            [colors]="barChartFarmOptions.colors"
                            [tooltip]="barChartFarmOptions.tooltip"
                            class="w-full h-full">
                        </apx-chart>
                    </ng-container>

                    <ng-template #noBarFarmData>
                        <div class="flex items-center justify-center h-[300px]">
                            <span class="text-sm text-gray-500">
                                Nenhum dado disponível para o gráfico.
                            </span>
                        </div>
                    </ng-template>

                    <!-- Legenda -->
                    <div
                        class="mt-6 flex justify-center w-full"
                        *ngIf="hasBarChartop10FarmsData()">
                        <div
                            class="flex flex-wrap justify-center gap-4 max-w-full">
                            <ng-container
                                *ngFor="
                                    let farm of analysisByFarm.slice(0, 5);
                                    let i = index
                                ">
                                <div class="flex items-center gap-2 px-3 py-1">
                                    <div
                                        class="w-4 h-4 rounded-full"
                                        [style.backgroundColor]="
                                            farmBarColors[i]
                                        "></div>
                                    <span
                                        class="text-sm max-w-[300px] truncate"
                                        [matTooltip]="farm.farm">
                                        {{ i + 1 }}. {{ farm.farm }}
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MOBILE -->

            <!-- Header para Mobile -->
            <div *ngIf="isMobile" class="pt-3 space-y-4">
                <!-- Título -->
                <div
                    class="flex items-center font-sans text-xl text-neutral-500 font-bold">
                    Visão geral de Estoques
                </div>

                <!-- Filtro Regional -->
                <div class="w-full">
                    <mat-form-field class="w-full">
                        <mat-select
                            [(ngModel)]="selectedRegional"
                            (selectionChange)="
                                onChangeRegional(
                                    $event.value,
                                    $event.source.triggerValue
                                )
                            "
                            [placeholder]="'Selecione a regional'">
                            <mat-option [value]="null">Nenhuma</mat-option>
                            <mat-option
                                *ngFor="let regional of regionals"
                                [value]="regional.id">
                                {{ regional.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Filtro Fazenda -->
                <div class="w-full">
                    <mat-form-field class="w-full">
                        <mat-select
                            [(ngModel)]="selectedFarm"
                            (selectionChange)="
                                onChangeFarm(
                                    $event.value,
                                    $event.source.triggerValue
                                )
                            "
                            [placeholder]="'Selecione a fazenda'">
                            <mat-option [value]="null">Nenhuma</mat-option>
                            <mat-option
                                *ngFor="let farm of farms"
                                [value]="farm.id">
                                {{ farm.farm_name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Filtros para mobile -->
            <div
                *ngIf="isMobile"
                class="w-full border-b pb-2 flex justify-center">
                <ng-container *ngIf="filters && filters.length">
                    <div class="flex flex-col items-center gap-2">
                        <ng-container *ngFor="let filter of filters">
                            <div
                                class="flex items-center gap-1 py-1 px-4 rounded-full text-sm font-medium text-gray-700 bg-gray-200 shadow-sm">
                                <div>
                                    <strong>{{ filter.label }}</strong
                                    >: {{ filter.value }}
                                </div>
                                <mat-icon
                                    class="cursor-pointer text-gray-600"
                                    [svgIcon]="'heroicons_solid:x-circle'"
                                    (click)="removeFilter(filter)">
                                </mat-icon>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>

            <!-- Content Cards mobile -->
            <div *ngIf="isMobile" class="grid grid-cols-1 gap-y-4 px-4 pt-5">
                <div
                    class="rounded-lg shadow-lg bg-card w-full pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Estoques Controlados</div>
                        <div class="text-3xl font-bold py-2">
                            {{ overview.totalRecords || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{ 100 }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-full pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Total Geral em Estoques</div>
                        <div class="text-3xl font-bold py-2">
                            {{ overview.totalGlobalStock || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{ 100 }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-full pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Total de Lotes controlados</div>
                        <div class="text-3xl font-bold py-2">
                            {{ totalBatches || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{ 100 }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-full pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Lotes Expirando</div>
                        <div class="text-3xl font-bold py-2">
                            {{ nearingExpiryCount || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{
                                (nearingExpiryCount / totalBatches) * 100
                                    | number : '1.2-2'
                            }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-full pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Lotes Bloqueados</div>
                        <div class="text-3xl font-bold py-2">
                            <mat-icon
                                [svgIcon]="'heroicons_solid:fire'"
                                class="text-red-500"></mat-icon>
                            &nbsp;<font color="red">{{
                                blockedCount || 0 | number
                            }}</font>
                        </div>
                        <div class="text-sm">
                            Representa
                            {{
                                (blockedCount / totalBatches) * 100
                                    | number : '1.2-2'
                            }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-full pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">
                            Lotes <strong>OnDemand</strong>
                        </div>
                        <div class="text-3xl font-bold py-2">
                            {{ modeDistribution.OnDemand || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{
                                (modeDistribution.OnDemand / totalBatches) * 100
                                    | number : '1.2-2'
                            }}%
                        </div>
                    </div>
                </div>
                <div
                    class="rounded-lg shadow-lg bg-card w-full pl-3 text-neutral-700"
                    [ngClass]="{ 'border-left-bi': selectedTheme === 'BI' }">
                    <div class="py-2">
                        <div class="text-md">Lotes <strong>OnFarm</strong></div>
                        <div class="text-3xl font-bold py-2">
                            {{ modeDistribution.OnFarm || 0 | number }}
                        </div>
                        <div class="text-sm">
                            Representa
                            {{
                                (modeDistribution.OnFarm / totalBatches) * 100
                                    | number : '1.2-2'
                            }}%
                        </div>
                    </div>
                </div>

                <div class="flex justify-center w-full">
                    <div class="flex py-5 items-center">
                        <button
                            class="ml-4 bg-gray-500 text-white text-sm"
                            mat-flat-button
                            (click)="switchTab()">
                            <span class="ml-2 mr-1"
                                >Acessar Lista de Estoques</span
                            >
                        </button>
                    </div>
                </div>
            </div>

            <!-- Content Charts description mobile-->
            <div
                *ngIf="isMobile"
                class="grid grid-cols-2 md:grid-cols-4 pt-5 pl-4 gap-y-4">
                <div class="col-span-2 flex justify-center">
                    <div
                        class="text-md font-bold text-center"
                        style="color: rgb(115, 115, 155)">
                        Distribuição de Lotes: OnFarm | OnDemand
                    </div>
                </div>
            </div>

            <!-- Mobile - Content Charts Pizza e barras Lado a Lado-->
            <div
                *ngIf="isMobile"
                class="pt-8 grid grid-cols-1 gap-4 w-full items-center">
                <!-- Gráfico de Pizza -->
                <div
                    class="w-full grid grid-cols-1 gap-4 items-center overflow-x-auto">
                    <!-- gráfico e legendas -->
                    <ng-container *ngIf="hasPieChartData(); else noPieData">
                        <div class="flex justify-center w-full">
                            <div class="w-[250px] h-[250px]">
                                <apx-chart
                                    [series]="charrt.series"
                                    [chart]="charrt.chart"
                                    [labels]="charrt.labels"
                                    [legend]="charrt.legend"
                                    [dataLabels]="charrt.dataLabels"
                                    [colors]="charrt.colors"
                                    class="w-full h-full">
                                </apx-chart>
                            </div>
                        </div>
                        <!-- legenda -->
                        <div class="w-full px-4" *ngIf="hasPieChartData()">
                            <div class="space-y-2">
                                <div
                                    *ngFor="
                                        let label of charrt.labels;
                                        let i = index
                                    "
                                    class="flex items-center justify-between border-b pb-1">
                                    <div class="flex items-center gap-2">
                                        <div
                                            class="w-4 h-4 rounded-full"
                                            [style.backgroundColor]="
                                                charrt.colors[i]
                                            "></div>
                                        <span
                                            class="text-sm text-neutral-600"
                                            >{{ label }}</span
                                        >
                                    </div>
                                    <span
                                        class="text-sm font-bold text-neutral-800"
                                        >{{ charrt.series[i] }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noPieData>
                        <div
                            class="col-span-3 flex items-center justify-center h-[300px]">
                            <span class="text-sm text-gray-500">
                                Nenhum dado disponível para o gráfico.
                            </span>
                        </div>
                    </ng-template>
                </div>

                <!-- Content Charts description Tela-->
                <div
                    *ngIf="isMobile"
                    class="grid grid-cols-2 md:grid-cols-4 pt-5 pl-4 gap-y-4 mt-2 -mb-1">
                    <div class="col-span-2 flex justify-center">
                        <div
                            class="text-md font-bold text-center"
                            style="color: rgb(115, 115, 155)">
                            Top 10 Produtos - Mais próximos do mínimo
                        </div>
                    </div>
                </div>

                <!-- Gráfico de Barras -->
                <div class="rounded-lg bg-card p-4 w-full overflow-x-auto">
                    <div class="min-w-[600px]">
                        <ng-container
                            *ngIf="
                                hasBarChartop10ProductsData();
                                else noBarDataProducts
                            ">
                            <apx-chart
                                [series]="barChartOptions.series"
                                [chart]="barChartOptions.chart"
                                [xaxis]="barChartOptions.xaxis"
                                [yaxis]="barChartOptions.yaxis"
                                [plotOptions]="barChartOptions.plotOptions"
                                [dataLabels]="barChartOptions.dataLabels"
                                [colors]="barChartOptions.colors"
                                [tooltip]="barChartOptions.tooltip"
                                class="w-full h-full">
                            </apx-chart>
                        </ng-container>

                        <ng-template #noBarDataProducts>
                            <div
                                class="flex items-center justify-center h-[300px]">
                                <span class="text-sm text-gray-500">
                                    Nenhum dado disponível para o gráfico.
                                </span>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>

            <!-- Mobile - Content Charts description -->
            <div
                *ngIf="isMobile"
                class="grid grid-cols-4 md:grid-cols-4 pt-5 pl-4 gap-y-4 mt-4 -mb-2">
                <div class="col-span-4 flex justify-center">
                    <div
                        class="text-md font-bold text-center"
                        style="color: rgb(115, 115, 155)">
                        Top 5 Produtos - Abaixo do Mínimo
                    </div>
                </div>
            </div>

            <!-- Tela - Gráficos em uma única linha: Abaixo do Mínimo -->
            <div
                *ngIf="isMobile"
                class="pt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 w-full">
                <!-- Gráfico de Produtos Abaixo do Mínimo -->
                <div class="bg-card p-4 w-full overflow-x-auto">
                    <ng-container
                        *ngIf="barChartBelowMinimumOptions?.series?.[0]?.data?.length; else noBelowMin">
                        <apx-chart
                            [series]="barChartBelowMinimumOptions.series"
                            [chart]="barChartBelowMinimumOptions.chart"
                            [xaxis]="barChartBelowMinimumOptions.xaxis"
                            [yaxis]="barChartBelowMinimumOptions.yaxis"
                            [plotOptions]="
                                barChartBelowMinimumOptions.plotOptions
                            "
                            [dataLabels]="
                                barChartBelowMinimumOptions.dataLabels
                            "
                            [colors]="barChartBelowMinimumOptions.colors"
                            [tooltip]="barChartBelowMinimumOptions.tooltip"
                            class="w-full h-full">
                        </apx-chart>
                    </ng-container>

                    <ng-template #noBelowMin>
                        <div class="flex justify-center h-[300px] items-center">
                            <span class="text-sm text-gray-500">
                                Nenhum produto está abaixo do mínimo atualmente.
                            </span>
                        </div>
                    </ng-template>
                </div>
            </div>

            <!-- Mobile - Content Charts description -->
            <div
                *ngIf="isMobile"
                class="grid grid-cols-4 md:grid-cols-4 pt-5 pl-4 gap-y-4 mt-4 -mb-2">
                <div class="col-span-4 flex justify-center">
                    <div
                        class="text-md font-bold text-center"
                        style="color: rgb(115, 115, 155)">
                        Top 5 - Estoques por Fazenda
                    </div>
                </div>
            </div>

            <!-- Mobile - Gráfico top10 de estoque em fazendas  -->
            <div *ngIf="isMobile" class="pt-8 w-full">
                <!-- Gráfico em full width -->
                <div class="bg-card p-4 w-full overflow-x-auto">
                    <div class="min-w-[1024px]">
                        <ng-container
                            *ngIf="
                                hasBarChartop10FarmsData();
                                else noBarFarmData
                            ">
                            <apx-chart
                                [series]="barChartFarmOptions.series"
                                [chart]="barChartFarmOptions.chart"
                                [xaxis]="barChartFarmOptions.xaxis"
                                [yaxis]="barChartFarmOptions.yaxis"
                                [plotOptions]="barChartFarmOptions.plotOptions"
                                [dataLabels]="barChartFarmOptions.dataLabels"
                                [colors]="barChartFarmOptions.colors"
                                [tooltip]="barChartFarmOptions.tooltip"
                                class="w-full h-full">
                            </apx-chart>
                        </ng-container>

                        <ng-template #noBarFarmData>
                            <div
                                class="col-span-3 flex items-center justify-center h-[300px]">
                                <span class="text-sm text-gray-500">
                                    Nenhum dado disponível para o gráfico.
                                </span>
                            </div>
                        </ng-template>
                    </div>

                    <!-- Legendas centralizadas abaixo do gráfico -->
                    <div
                        class="mt-6 flex justify-start w-full"
                        *ngIf="hasBarChartop10FarmsData()">
                        <div
                            class="flex flex-wrap justify-start gap-4 max-w-full">
                            <ng-container
                                *ngFor="
                                    let farm of analysisByFarm.slice(0, 5);
                                    let i = index
                                ">
                                <div class="flex items-start gap-2 px-3 py-1">
                                    <div
                                        class="w-4 h-4 rounded-full"
                                        [style.backgroundColor]="
                                            farmBarColors[i]
                                        "></div>
                                    <span
                                        class="text-sm max-w-[300px] truncate"
                                        [matTooltip]="farm.farm">
                                        {{ i + 1 }}. {{ farm.farm }}
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <br />
        </div>
    </div>
</div>
<br />
